window.allCardProductData = [];
const imagesToCache = [];
window.setOnClickVariant = false;

//! Called in "quick-add.js" when modal renders
function modalFirstlyLoaded(modal) {
  setTimeout(() => {
    initializeModalSwiper(modal);
    addClickOnVariants(modal);
    bodyOverFlow();
    setSizeChartLink(modal);
    ReloadSmartWishlist();
  }, 1000);
}

function setSizeChartLink(modal) {
  let productId = modal.querySelector(
    'product-info form input[name="product-id"]'
  ).value;
  let productData = allCardProductData[0];
  let origin = window.location.origin;
  let handle = productData.productData.handle;
  let link = origin + "/products/" + handle;
  console.log(link);
  const pElement = modal.querySelector(".main-pdpsizepop");
  if (pElement) {
    const aElement = document.createElement("a");
    aElement.href = link; // Replace with your desired link
    aElement.textContent = pElement.textContent;
    aElement.className = "main-pdpsizepop";
    pElement.parentNode.replaceChild(aElement, pElement);
  }
}
//! Set the body overflow hidden
function bodyOverFlow() {
  let body = document.body;
  body.style.overflow = "hidden";
  body.style.position = "fixed";
  body.style.width = "100%";
}

//! Adding click event on color variants
function addClickOnVariants(modal) {
  let colorVariants = modal.querySelectorAll(".url_circle");
  if (colorVariants) {
    Array.from(colorVariants).forEach((colorVariant) => {
      colorVariant.addEventListener("click", handleColorVariantClick);
    });
  }
}

//!  Getting the clicked variant's object
function handleColorVariantClick(event) {
  let clickedVariant = event.target;
  let openedModal = clickedVariant.closest(".quick-add-modal-parent");
  event.preventDefault();
  let clickedVariantId = clickedVariant.getAttribute("data-id");
  let productData = allCardProductData[0];
  let variantObject = productData.productColorVariants.find((colorVariant) => {
    return colorVariant.color_variant_info.id === parseInt(clickedVariantId);
  });
  if (variantObject) {
    changeVendorName(openedModal, variantObject);
    changeTitle(openedModal, variantObject);
    updateSwiperImages(openedModal, variantObject);
    updateSizeVariants(openedModal, variantObject);
    addClickOnSizes(openedModal, variantObject);
    setClickColorActive(event);
    setOnClickTrue();
    setNewSizeChartLink(openedModal, variantObject);
  } else {
    console.log("No color variant object found with the given ID");
  }
}

function setNewSizeChartLink(openedModal, variantObject) {
  let origin = window.location.origin;
  let link = origin + "/products/" + variantObject.color_variant_info.handle;
  console.log(link);
  const pElement = openedModal.querySelector(".main-pdpsizepop");
  if (pElement) {
    const aElement = document.createElement("a");
    aElement.href = link; // Replace with your desired link
    aElement.textContent = pElement.textContent;
    aElement.className = "main-pdpsizepop";
    pElement.parentNode.replaceChild(aElement, pElement);
  }
}

function closeQuickModal() {
  let body = document.body;
  body.style.overflow = null;
  allCardProductData.length = 0;
  setOnClickVariant = false;
}

function setOnClickTrue() {
  if (!setOnClickVariant) {
    setOnClickVariant = true;
  }
}

function setClickColorActive(event) {
  let parentColorVariantsWrapper = event.target.closest(
    ".color_variant_wrapper_cs"
  );
  let allColorVariants = parentColorVariantsWrapper.querySelectorAll(
    ".product_color_variant_cs"
  );
  let activeVariant = event.target.querySelector(".product_color_variant_cs");
  console.log("🚀 ~ setClickColorActive ~ activeVariant:", activeVariant);
  allColorVariants.forEach((variant) => {
    if (variant.classList.contains("matched")) {
      variant.classList.remove("matched");
    }
  });
  activeVariant.classList.add("matched");
}

//! Adding click function on size variants on color change
function addClickOnSizes(openedModal, obj) {
  let sizesVariants = openedModal.querySelectorAll(
    ".product_variant_wrapper input"
  );
  if (sizesVariants) {
    Array.from(sizesVariants).forEach((sizeVariant) => {
      sizeVariant.addEventListener(
        "click",
        handleSizeVariantClick.bind(this, openedModal, obj)
      );
    });
  }
}

//! Getting click on size variant
function handleSizeVariantClick(openedModal, obj, event) {
  updateFormVariantID(openedModal, obj, event);
  updateVariantPrice(openedModal, obj, event);
}

function updateVariantPrice(openedModal, obj, event) {
  let clickedSize = event.target.value;
  let clickVariantObj = obj.color_variant_info.variants.find((variant) => {
    return parseInt(variant.option1) == parseInt(clickedSize);
  });
  let priceData = processVariantPrice(clickVariantObj);
  renderVariantPrice(openedModal, priceData);
}

function updateFormVariantID(openedModal, obj, event) {
  let clickSize = event.target.value;
  let variantParent = event.target.closest(".product_variant_wrapper");
  let variantParentInput = variantParent.querySelectorAll(
    ".product_variant_wrapper input"
  );
  let variantIdInform = openedModal.querySelector(
    "product-form input.product-variant-id"
  );
  let upperVariantIdInform = openedModal.querySelector('form input[name="id"]');
  let clickVariantObj = obj.color_variant_info.variants.find((variant) => {
    return parseInt(variant.option1) == parseInt(clickSize);
  });
  variantParentInput.forEach((input) => {
    input.removeAttribute("checked");
  });
  event.target.setAttribute("checked", "");
  variantIdInform.value = clickVariantObj.id;
  upperVariantIdInform.value = clickVariantObj.id;
}

//! Updating the quick view product form
function setProductFormInfo(openedModal, obj, variant) {
  let lowerProductIdInForm = openedModal.querySelector(
    'product-form input[name="product-id"]'
  );
  let lowerVariantIdInform = openedModal.querySelector(
    "product-form input.product-variant-id"
  );
  let upperProductIdInForm = openedModal.querySelector(
    'form input[name="product-id"]'
  );
  let upperVariantIdInform = openedModal.querySelector('form input[name="id"]');

  lowerProductIdInForm.value = obj.color_variant_info.id;
  upperProductIdInForm.value = obj.color_variant_info.id;
  upperVariantIdInform.value = variant.id;
  lowerVariantIdInform.value = variant.id;
}

//! Formatting the price of the selected size variant
function formatPrice(price) {
  return price ? (price / 100).toLocaleString("en-US") : "";
}

//! Process the price, compare price and discount
function processVariantPrice(variant) {
  const { price, compare_at_price } = variant;

  const formattedPrice = formatPrice(price);

  const data = {
    formattedPrice,
  };

  if (compare_at_price) {
    const formattedComparePrice = formatPrice(compare_at_price);
    const comparePriceNum = parseFloat(formattedComparePrice.replace(/,/g, ""));
    const priceNum = parseFloat(formattedPrice.replace(/,/g, ""));

    if (comparePriceNum > priceNum) {
      const discountAmount = comparePriceNum - priceNum;
      const discountPercentage = (discountAmount / comparePriceNum) * 100;
      data.formattedComparePrice = formattedComparePrice;
      data.discountPercentage = Math.ceil(discountPercentage);
    }
  }

  return data;
}

//! Renders the size variant price when size of a color is selected
function renderVariantPrice(openedModal, priceData) {
  let price = openedModal.querySelector(
    "span.price-item.price-item--sale.price-item--last"
  );
  let compareAtPrice = openedModal.querySelector(
    "s.price-item.price-item--regular"
  );
  let priceDiscount = openedModal.querySelector(
    ".main_discount_badge span.discount.discount_fnt_sze"
  );

  price.innerText = `₹ ${priceData.formattedPrice}`;

  if (!priceData.formattedComparePrice) {
    compareAtPrice.innerText = "";
    priceDiscount.innerText = "";
    compareAtPrice.style.display = "none";
    priceDiscount.style.display = "none";
    return;
  } else {
    compareAtPrice.innerText = `₹ ${priceData.formattedComparePrice}`;
    priceDiscount.innerText = `${priceData.discountPercentage}% Off`;
    compareAtPrice.style.display = "inline-block";
    priceDiscount.style.display = "inline-block";
  }
}

//! Changing the size variants on color variant change
function updateSizeVariants(openedModal, obj) {
  let sizeVariantsWrapper = openedModal.querySelector(
    ".product_variant_wrapper"
  );
  let variants = obj.color_variant_info.variants;
  let sectionId = sizeVariantsWrapper.getAttribute("data-section-id");
  let setVariantChecked = false;
  // console.log(obj);
  // console.log(sizeVariantsWrapper);

  sizeVariantsWrapper.innerHTML = "";

  variants.forEach((variant, index) => {
    let variantInput = document.createElement("input");
    variantInput.type = "radio";
    variantInput.id = `${sectionId}-1-${index}`;
    variantInput.name = "Select size";
    variantInput.value = `${variant.option1}`;
    variantInput.setAttribute("form", `product-form-${sectionId}`);
    if (!setVariantChecked && variant.available) {
      variantInput.setAttribute("checked", "");
      setVariantChecked = true;
      let priceData = processVariantPrice(variant);
      renderVariantPrice(openedModal, priceData);
      setProductFormInfo(openedModal, obj, variant);
    }
    if (!variant.available) variantInput.classList.add("disabled");

    let variantLabel = document.createElement("label");
    variantLabel.setAttribute("for", `${sectionId}-1-${index}`);
    variantLabel.innerText = `${variant.option1}`;

    let variantSpan = document.createElement("span");
    variantSpan.classList.add("visually-hidden", "label-unavailable");
    variantSpan.innerText = "Variant sold out or unavailable";

    sizeVariantsWrapper.appendChild(variantInput);
    sizeVariantsWrapper.appendChild(variantLabel);
    variantLabel.appendChild(variantSpan);
  });
}

//! Changing the swiper images on variant change
function updateSwiperImages(openedModal, obj) {
  let bigSlider = openedModal.querySelector(".mySwiperancs .swiper-wrapper");
  let smallSlider = openedModal.querySelector(".mySwipercsan .swiper-wrapper");
  let variantImages = obj.color_variant_info.media;
  let variantImagesAlt = obj.color_variant_info.title;

  bigSlider.innerHTML = "";
  variantImages.forEach((image) => {
    let slide = document.createElement("div");
    slide.classList.add("swiper-slide");
    let imageDiv = document.createElement("div");
    imageDiv.classList.add("bigger_firstslide");
    let img = `<img srcset="${image.src} 375w,${image.src} 550w,${image.src} 750w,${image.src} 810w" sizes="100vw" src="${image.src}" width="${image.width}" height="${image.height}" alt="${variantImagesAlt}">`;
    bigSlider.appendChild(slide);
    slide.appendChild(imageDiv);
    slide.innerHTML = img;
  });

  smallSlider.innerHTML = "";
  variantImages.forEach((image) => {
    let slide = document.createElement("div");
    slide.classList.add("swiper-slide");
    slide.classList.add("external_wd");
    let imageDiv = document.createElement("div");
    imageDiv.classList.add("small_thumbnails");
    let img = `<img srcset="${image.src} 375w,${image.src} 550w,${image.src} 750w,${image.src} 810w" sizes="100vw" src="${image.src}" width="${image.width}" height="${image.height}">`;
    smallSlider.appendChild(slide);
    slide.appendChild(imageDiv);
    slide.innerHTML = img;
  });
  initialiseMainSwiper();
}

//! Changing the Title on variant change
function changeTitle(openedModal, obj) {
  let title = openedModal.querySelector(".product__title h2");
  title.textContent = "";
  title.textContent = obj.color_variant_info.title;
}

//! Changing the Vendor name on variant change
function changeVendorName(openedModal, obj) {
  let vendorName = openedModal.querySelector(".custom-vendor");
  vendorName.textContent = "";
  vendorName.textContent = obj.color_variant_info.vendor;
}

//! Initializing the modal swiper
function initializeModalSwiper(modal) {
  let scripts = modal.getElementsByTagName("script");
  Array.from(scripts).forEach((script) => {
    if (script.hasAttribute("data-value")) {
      const scriptContent = script.textContent;
      const newScript = document.createElement("script");
      newScript.textContent = scriptContent;
      document.head.appendChild(newScript);
      initialiseMainSwiper();
    }
  });
}

//! Getting the json of the product and its variant
function getProductJson(btn) {
  let dataElement =
    btn.parentElement.parentElement.parentElement.nextElementSibling;
  let decodedData = atob(dataElement.innerHTML);
  let productDataJson = JSON.parse(decodedData);
  allCardProductData.push(productDataJson);

  //! Pushing the images of the product into the imagesToCache Array.
  if (productDataJson.productData && productDataJson.productData.images) {
    allCardProductData[0].productData.images.forEach((url) => {
      imagesToCache.push(url);
    });
  }

  //! Pushing the images of the product into the imagesToCache Array.
  if (productDataJson.productColorVariants) {
    productDataJson.productColorVariants.forEach((variant) => {
      if (variant.color_variant_info && variant.color_variant_info.images) {
        variant.color_variant_info.images.forEach((imagesUrl) => {
          imagesToCache.push(imagesUrl);
        });
      }
    });
  }

  cacheImages(imagesToCache, false);
}
function openModal(event) {
  let clickedBtn = event.target;
  let btnParent = clickedBtn.closest(".card__content");
  let modalOpenerBtn = btnParent.querySelector(
    'modal-opener button[type="submit"]'
  );
  let atcBtn = btnParent.querySelector('product-form button[type="submit"]');
  if (modalOpenerBtn) {
    modalOpenerBtn.click();
  } else {
    atcBtn.click();
  }
}
//! Cacheing all the images of product and its variants.

function cacheImages(array, waitForOtherResources, timeout) {
  if (array.length !== 0) {
    if (!cacheImages.list) {
      cacheImages.list = [];
    }
    let loaded = false;
    let list = cacheImages.list;
    let imgs = array.slice(0);
    let t = timeout || 15 * 1000;
    let timer;

    if (!waitForOtherResources || document.readyState === "complete") {
      loadNow();
    } else {
      window.addEventListener("load", function () {
        clearTimeout(timer);
        loadNow();
      });
      timer = setTimeout(loadNow, t);
    }

    function loadNow() {
      if (!loaded) {
        loaded = true;
        for (var i = 0; i < imgs.length; i++) {
          var img = new Image();
          img.onload =
            img.onerror =
            img.onabort =
              function () {
                var index = list.indexOf(this);
                if (index !== -1) {
                  list.splice(index, 1);
                }
              };
          list.push(img);
          img.src = imgs[i];
        }
      }
    }
  }
}

function handleDummyQuickViewAtc(btn) {
  let realBtnWrapper = btn.parentElement.previousElementSibling;
  console.log("🚀 ~ handleDummyQuickViewAtc ~ realBtnWrapper:", realBtnWrapper);
  let realBtn = realBtnWrapper.querySelector(
    '.product-form__buttons.atc-dflex button[type="submit"]'
  );
  realBtn.click();
}
function handleDummyQuickViewPayment(btn) {
  let realBtnWrapper = btn.parentElement.previousElementSibling;
  let realBtn = realBtnWrapper.querySelector(
    ".shopify-payment-button__button.shopify-payment-button__button--unbranded"
  );
  realBtn.click();
}
